<script setup>
import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import AppHeader from '@/components/sections/Header.vue'
import AppFooter from '@/components/sections/Footer.vue'
// import AppPreloader from './components/ui/AppPreloader.vue'
import PopupManager from '@/components/popup/PopupManager.vue'
import { setPopupRef } from '@/components/popup/usePopup'
import { initYandexMetrika } from '@/utils/metrika'

import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)

const popupRef = ref(null)

function forceRefresh() {
	return new Promise((resolve) => {
		ScrollTrigger.refresh(true)
		requestAnimationFrame(resolve)
	})
}

onMounted(async () => {
	if (popupRef.value) setPopupRef(popupRef.value)
	initYandexMetrika()
})

onBeforeUnmount(() => {
	window.removeEventListener('load', forceRefresh)
})
</script>

<template>
	<AppHeader />
	<main class="page">
		<RouterView />
	</main>
	<AppFooter />
	<PopupManager ref="popupRef" />
</template>

<style scoped>
body._prewarming {
	visibility: hidden;
}
</style>
